<div class="modal-content" *transloco="let t; prefix: 'maintenanceOverview.modals.eventSchedule'">
  <div class="modal-header">
    <h5 class="modal-title mb-0">{{ t('title') }}</h5>

    <div class="d-flex align-items-center gap-2">
      @if (!isEditingDetails) {
        <button type="button" class="btn-close" [attr.aria-label]="t('toggleEdit')" (click)="toggleEditDetails()">
          <i class="ph ph-pencil-simple"></i>
        </button>
      }

      <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()"><i class="ph ph-x"></i></button>
    </div>
  </div>

  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label>{{ t('assetName') }}</label>
        <input class="form-control readonly" type="text" formControlName="asset" readonly />
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('make') }}</label>
          <input class="form-control readonly" type="text" formControlName="make" readonly />
        </div>

        <div class="form-group half-width">
          <label>{{ t('model') }}</label>
          <input class="form-control readonly" type="text" formControlName="model" readonly />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('odometerReading') }}</label>
          <input class="form-control readonly" type="text" formControlName="odometer" readonly />
        </div>

        <div class="form-group half-width">
          <label>{{ t('serviceType') }} <span class="required">*</span></label>

          @if (isEditingDetails) {
            <div ngbDropdown class="custom-dropdown" [autoClose]="true">
              <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
                <div class="d-flex flex-row justify-content-between dropdown-inner">
                  <span class="align-middle">{{ serviceTypeLabel }}</span>
                  <i class="ph ph-caret-down lh-base"></i>
                </div>
              </button>

              <div ngbDropdownMenu>
                <div class="d-flex flex-column">
                  @for (option of serviceTypeOptions; track option.value) {
                    <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onServiceTypeSelect(option.value, $event)">
                      {{ option.label }}
                    </button>
                  }
                </div>
              </div>
            </div>
          } @else {
            <input class="form-control readonly" type="text" [value]="serviceTypeLabel" readonly />
          }

          @if (form.get('serviceType')?.invalid && form.get('serviceType')?.touched) {
            <div class="error-message">{{ t('maintenanceTypeRequired') }}</div>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('serviceCentre') }} <span class="required">*</span></label>

          @if (isEditingDetails) {
            <div ngbDropdown class="custom-dropdown" [autoClose]="true">
              <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
                <div class="d-flex flex-row justify-content-between dropdown-inner">
                  <span class="align-middle">{{ serviceCentreLabel }}</span>
                  <i class="ph ph-caret-down lh-base"></i>
                </div>
              </button>

              <div ngbDropdownMenu>
                <div class="d-flex flex-column">
                  @if (isLoadingServiceCentres) {
                    <div class="dropdown-loading">
                      <span class="spinner-border spinner-border-sm"></span>
                      <span>{{ t('loadingServiceCentres') }}</span>
                    </div>
                  } @else if (serviceCentres.length === 0) {
                    <div class="dropdown-loading">
                      <span>{{ t('noServiceCentresFound') }}</span>
                    </div>
                  } @else {
                    @for (s of serviceCentres; track s.id) {
                      <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onServiceCentreSelect(s, $event)">
                        {{ s.name }}
                      </button>
                    }
                  }
                </div>
              </div>
            </div>
          } @else {
            <input class="form-control readonly" type="text" [value]="serviceCentreLabel" readonly />
          }

          @if (form.get('serviceCentre')?.invalid && form.get('serviceCentre')?.touched) {
            <div class="error-message">{{ t('serviceCentreRequired') }}</div>
          }
        </div>

        <div class="form-group half-width">
          @if (isEditingDetails) {
            <app-flatpickr-date-picker
              [label]="t('scheduledDate')"
              [value]="scheduledDateValue"
              (valueChange)="onScheduledDateChange($event)"
              [dateFormat]="'Y/m/d H:i'"
              [yearsAhead]="5"
              [yearsBack]="0"
              [required]="true"
              [enableTime]="true"
              [time24hr]="true"
              [altFormat]="'d/m/Y H:i'"
              [placeholder]="t('scheduledDatePlaceholder')">
            </app-flatpickr-date-picker>
          } @else {
            <label>{{ t('scheduledDate') }} <span class="required">*</span></label>
            <input class="form-control readonly" type="text" [value]="scheduledDateValue" readonly />
          }

          @if (form.get('scheduledDate')?.invalid && form.get('scheduledDate')?.touched) {
            <div class="error-message">{{ t('scheduledDateRequired') }}</div>
          }
        </div>
      </div>

      <div class="form-group">
        <label>{{ t('serviceItems') }}</label>

        <div class="parts-display-area readonly">
          <div class="chips-wrapper">
            @if (selectedItems.length === 0) {
              <span class="placeholder-text">{{ t('selectServiceItems') }}</span>
            }

            @for (item of selectedItems; track item) {
              <span class="part-chip readonly">{{ item }}</span>
            }
          </div>
        </div>
      </div>

      <div class="modal-footer">
        @if (isEditingDetails) {
          <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>
          <button type="submit" class="add-btn" [disabled]="isLoading || form.invalid || !hasChanges">
            @if (isLoading) {
              <span class="spinner-border"></span>
            }
            @if (!isLoading) {
              <span>{{ t('saveChanges') }}</span>
            }
          </button>
        }
      </div>
    </form>
  </div>
</div>
